import { Component, ContentChild, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'flow-chart-container',
  templateUrl: './chart-container.component.html',
  styleUrls: ['./chart-container.component.scss'],
})
export class ChartContainerComponent {
  @Input() title: string;
  @Input() selectedDate: string;
  @Input() hasData: boolean;
  @Input() tooltip: string;
  @Input() hasCompareSlot: boolean = true;
  @ViewChild('filtersSlot', { static: false }) filtersSlot!: ElementRef;
  @ContentChild('filters') filters!: any;

}
